import module from 'empresas/module.js'

export const schema = {
  empresas: {empresa_id: 'number'},
  empresa_interna: 'boolean',
  regimen_fiscal_id: 'number',
  editable: 'boolean',
}

export class EmpresasService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get(`/api/empresas`, {schema})
  }

  post (data) {
    let formData = new global.FormData()
    Object.keys(data).forEach((keys) => (formData.append(keys, data[keys])))

    return this.$http.post('/api/empresas', formData)
  }
}

module.service('Empresas', EmpresasService)



// WEBPACK FOOTER //
// ./src/empresas/services/empresas.js